<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_house-editor(
          @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
              @click="onCloseModal()"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .house-editor
              .house-editor__title
                h2.title {{title}}
              .house-editor__form
                .form
                  .form__elem
                    .form-elem(
                      :class="{'form-elem_error':fieldsErrors.house.value}"
                    )
                      .form-elem__title Корпус
                      .form-elem__body
                        simple-select-form(
                        :list-data="housesList"
                        :default-value="fields.house"
                        @onChangeDefaultValue="changeHouse"
                        type="house"
                        :specific-choice="true"
                        )
                  .form__elem
                    .form-elem(
                    :class="{'form-elem_error':fieldsErrors.price.value}"
                    )
                      .form-elem__title Цена
                      .form-elem__body
                        input.input.input_full(
                        v-model="fields.price"
                        @input="resetError('price')"
                        ref="price"
                        )
                  .form__elem
                    .form-elem(
                    :class="{'form-elem_error':fieldsErrors.capacity.value}"
                    )
                      .form-elem__title Количество мест
                      .form-elem__body
                        input.input.input_full(
                        v-model="fields.capacity"
                        @input="resetError('capacity')"
                        ref="capacity"
                        )
                  .form__elem
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_full(
                        @click.prevent="onSaveHouse()"
                        )
                          .button__text {{buttonText}}
                      .form-elem__error(
                        v-if="currentErrorMessage.length > 0"
                      ) {{currentErrorMessage}}

</template>

<script>
import {mapActions} from "vuex";
import SimpleSelectForm from "../simpleSelectForm/SimpleSelectForm";
import Inputmask from "inputmask";

export default {
  name: "QuotaHouseEditorModal",
  components: {
    SimpleSelectForm,
    Inputmask
  },
  props: {
    houses: {
      type: Array,
      default: () => ([])
    },
    currentHouse: {
      type: Object,
      default: () => ({})
    },
    quota: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      fields: {
        house: {
          value: null,
          text: "Выберите корпус"
        },
        capacity: "",
        price: ""
      },
      fieldsErrors: {
        house: {
          value: false,
          message: "Выберите корпус"
        },
        price: {
          value: false,
          message: "Введите цену"
        },
        capacity: {
          value: false,
          message: "Введите количество мест"
        }
      },
      currentErrorMessage: "",
      priceMask: new Inputmask("decimal", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        digits: 2,
        max: 999999.99
      }),
      capacityMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        max: 32000
      })
    };
  },
  computed: {
    mode() {
      if (this.currentHouse) {
        return "edit";
      }
      return "create";
    },
    housesList() {
      const arr = this.houses.map(item => {
        return {
          value: item.id,
          text: item.name
        };
      });
      return arr;
    },
    buttonText() {
      if (this.mode === "edit") {
        return "Обновить";
      }
      return "Добавить";
    },
    title() {
      if (this.mode === "edit") {
        return "Редактирование корпуса";
      }
      return "Добавление корпуса";
    }

  },
  methods: {
    ...mapActions(["createQuotasHouse", "updateQuotasHouse"]),
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    changeHouse(data, type) {
      this.fields[type] = data;
      this.resetError(type);
    },
    resetError(field) {
      this.fieldsErrors[field].value = false;
      this.currentErrorMessage = "";
    },
    validation() {
      const errors = [];
      if (!this.fields.house.value) {
        errors.push("house");
      }
      if (this.fields.price.length === 0) {
        errors.push("price");
      }
      if (this.fields.capacity.length === 0) {
        errors.push("capacity");
      }
      if (errors.length > 0) {
        errors.forEach(err => {
          this.fieldsErrors[err].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    errorProcessing(data) {
      if (data.non_field_errors) {
        if (data.non_field_errors[0].code === "unique") {
          this.fieldsErrors.house.value = true;
          this.currentErrorMessage = "Этот корпус уже есть в квоте";
          return;
        }
        if (data.non_field_errors[0].code === "invalid") {
          this.fieldsErrors.capacity.value = true;
        }
        this.currentErrorMessage = data.non_field_errors[0].message;
      }
      if (data.capacity) {
        this.fieldsErrors.capacity.value = true;
        this.currentErrorMessage = data.capacity[0].message;
      }
      if (data.price) {
        this.fieldsErrors.price.value = true;
        this.currentErrorMessage = data.price[0].message;
      }
    },
    onSaveHouse() {
      if (!this.validation()) {
        return false;
      };
      const data = {
        price: this.fields.price,
        capacity: this.fields.capacity,
        quota: this.quota,
        house: this.fields.house.value
      };
      if (this.mode === "edit") {
        this.updateQuotasHouse({
          data: data,
          id: this.currentHouse.id
        }).then(res => {
          if (res.status === 200) {
            this.$emit("add-quotas-house");
            this.$emit("close");
          } else if (res.status === 400) {
            this.errorProcessing(res.data);
          }
        });
      } else if (this.mode === "create") {
        this.createQuotasHouse(data).then(res => {
          if (res.status === 201) {
            this.$emit("add-quotas-house");
            this.$emit("close");
          } else if (res.status === 400) {
            this.errorProcessing(res.data);
          }
        });
      }
    }
  },
  mounted() {
    this.priceMask.mask(this.$refs.price);
    this.capacityMask.mask(this.$refs.capacity);
    if (this.mode === "edit") {
      this.fields.price = this.currentHouse.price;
      this.fields.capacity = this.currentHouse.capacity;
      this.fields.house = this.housesList.find(item => {
        return item.text === this.currentHouse.house.name;
      });
    }
  }
};
</script>
